<span class="fade-in-top col-span-4 mt-2" [formGroup]="form">
    <div class="grid sm:grid-cols-4 gap-6 w-full">
        <div class="col-span-4">
            <mat-form-field id="documentUploadTitle" class="w-full">
                <mat-label>{{ 'label_title' | translate }}</mat-label>
                <input formControlName="title" maxlength="255" matInput />
                @if (this.form?.get('title')?.value?.length == 0) {
                    <mat-hint>
                        {{ 'info_document_title' | translate }}
                    </mat-hint>
                }
                @if (this.form?.get('title')?.value?.length > 0) {
                    <mat-hint class="ml-auto">
                        <span class="bold">{{ 255 - this.form?.get('title')?.value?.length }}</span>
                        {{
                            'info_characters_left'
                                | translate
                                    : {
                                          count: 255 - this.form?.get('title')?.value?.length,
                                      }
                                | lowercase
                        }}
                    </mat-hint>
                }
            </mat-form-field>
        </div>
        <div class="col-span-4">
            <div
                class="text-[14px] font-medium mb-1"
                [ngClass]="{
                    'validation-error-color': form?.get('description')?.hasError('required'),
                    'opacity-60': form.disabled,
                }"
            >
                {{ 'label_description' | translate }}
            </div>
            <ckeditor
                [disabled]="form?.get('description')?.disabled"
                [editor]="descriptionSingleDocEditor"
                [(ngModel)]="descriptionSingleDocTextHTML"
                name="descriptionSingleDocTextHTML"
                [ngModelOptions]="{ standalone: true }"
                [config]="{
                    alignment: {
                        options: ['left', 'right', 'center', 'justify'],
                    },
                    toolbar: ['heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList', 'link', '|', 'undo', 'redo'],
                }"
                (change)="descriptionSingleDocOnChange($event)"
                id="editorSingleDocDescription"
            >
            </ckeditor>
            <mat-hint class="float-left">
                {{ 'info_document_description' | translate }}
            </mat-hint>
        </div>
        <div class="col-span-4 mb-2">
            <div class="w-100 float-left radio-button-compact">
                <span class="separator-line block mt-[20px]"></span>
                <div class="text-[14px] font-medium mb-4">
                    {{ 'label_default_values' | translate }}
                </div>
                <mat-radio-group
                    formControlName="defaultValue"
                    (change)="changeDefaultValues($event.value)"
                    aria-label="Veldu sjálfvalið gildi"
                >
                    <mat-radio-button class="w-100 float-left pl-4" value="None">{{ 'label_none' | translate }}</mat-radio-button>
                    <mat-radio-button class="w-100 float-left pl-4 mt-1" value="LastSelection">{{
                        'label_last_selection' | translate
                    }}</mat-radio-button>
                    <mat-radio-button
                        [disabled]="!divisionDefaultValuesRes || divisionDefaultValuesRes.length == 0"
                        class="w-100 float-left pl-4 mt-1"
                        value="YourDivision"
                        >{{ 'label_your_division' | translate }}
                        @if (!divisionDefaultValuesRes || divisionDefaultValuesRes.length == 0) {
                            <span>({{ 'no_default_configs_exists_for_office_location' | translate | lowercase }})</span>
                        }
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div [ngClass]="includeSystem ? 'col-span-4 sm:col-span-2' : 'col-span-4'">
            <mat-form-field class="w-full">
                <mat-label>{{ 'label_type' | translate }}</mat-label>
                <mat-select formControlName="documentTypeId" [placeholder]="'label_type' | translate">
                    <mat-option [value]="null"></mat-option>
                    @for (type of typesDropDown; track type) {
                        <mat-option [value]="type.value">
                            {{ type.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        @if (includeSystem) {
            <div class="col-span-4 sm:col-span-2">
                <mat-form-field class="w-full">
                    <mat-label>{{ 'label_system' | translate }}</mat-label>
                    <mat-select formControlName="documentSystemId" [placeholder]="'label_system' | translate">
                        <mat-option [value]="null"></mat-option>
                        @for (sys of systemsDropDown; track sys) {
                            <mat-option [value]="sys.value">
                                {{ sys.viewValue }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        }
        <div class="col-span-4 sm:col-span-2">
            <mat-form-field class="w-full">
                <mat-label>{{ 'label_category' | translate }}</mat-label>
                <mat-select formControlName="documentCategoryId" [placeholder]="'label_category' | translate">
                    <mat-option [value]="null"></mat-option>
                    @for (cat of categoriesDropDown; track cat) {
                        <mat-option [value]="cat.value">
                            {{ cat.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-span-4 sm:col-span-2">
            <mat-form-field class="w-full">
                <mat-label>{{ 'label_subcategory' | translate }}</mat-label>
                <mat-select formControlName="documentSubcategoryId" [placeholder]="'label_subcategory' | translate">
                    <mat-option [value]="null"></mat-option>
                    @for (subCat of subcategoriesDropDown; track subCat) {
                        <mat-option [value]="subCat.value">
                            {{ subCat.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-span-4 sm:col-span-2">
            <mat-form-field class="w-full">
                <mat-label>{{ 'label_division' | translate }}</mat-label>
                <mat-select formControlName="svid" [placeholder]="'label_division' | translate">
                    <mat-option [value]="null"></mat-option>
                    @for (s of svidDropDown; track s) {
                        <mat-option [value]="s.value">
                            {{ s.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-span-4 sm:col-span-2">
            <mat-form-field class="w-full">
                <mat-label>{{ 'label_departement' | translate }}</mat-label>
                <mat-select formControlName="deild" [placeholder]="'label_departement' | translate">
                    <mat-option [value]="null"></mat-option>
                    @for (d of deildirDropDown; track d) {
                        <mat-option [value]="d.value">
                            {{ d.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        @if (includeDocumentDate) {
            <div class="col-span-4 sm:col-span-2">
                <mat-form-field class="float-left w-100">
                    <mat-label>{{ 'label_document_date' | translate }}</mat-label>
                    <input
                        class="date"
                        formControlName="documentDate"
                        matInput
                        [min]="todayDate"
                        [placeholder]="'label_document_date' | translate"
                        (click)="documentDate.open()"
                        [matDatepicker]="documentDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="documentDate"></mat-datepicker-toggle>
                    <mat-datepicker #documentDate></mat-datepicker>
                    @if (this.form?.get('dagsetning')?.hasError('required')) {
                        <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                    }
                </mat-form-field>
            </div>
        }
        <div [ngClass]="includeDocumentDate ? 'col-span-4 sm:col-span-2' : 'col-span-4'">
            <mat-form-field class="float-left w-100">
                <mat-label>{{ 'label_publication_date' | translate }}</mat-label>
                <input
                    class="date"
                    formControlName="publicationDate"
                    matInput
                    [min]="todayDate"
                    [placeholder]="'label_publication_date' | translate"
                    (click)="birtingardagur.open()"
                    [matDatepicker]="birtingardagur"
                />
                <mat-datepicker-toggle matSuffix [for]="birtingardagur"></mat-datepicker-toggle>
                <mat-datepicker #birtingardagur></mat-datepicker>
                @if (this.form?.get('publicationDate')?.hasError('required')) {
                    <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                }
            </mat-form-field>
        </div>

        <div class="col-span-4">
            <span class="separator-line block mt-[20px]"></span>
        </div>
        <div class="col-span-4 checkbox-compact">
            <mat-checkbox [color]="'primary'" formControlName="submitToPortalLSR">
                {{ 'label_submit_portal' | translate }}
            </mat-checkbox>
            <mat-checkbox [color]="'primary'" formControlName="submitToStafraentIsland" (change)="islandConfirmRead($event)">
                {{ 'label_submit_stafraent_island' | translate }}
            </mat-checkbox>
            <span class="separator-line block mt-[20px]"></span>
        </div>
    </div>
</span>
